import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { BreadCrumbDS } from './bread-crumb-ds'
import { BreadCrumbLegacy } from './legacy-bread-crumb'

import type { BreadCrumbProps } from './bread-crumb.types'

const BreadCrumb = (props: BreadCrumbProps) => {
  if (shouldUseDesignSystem()) {
    return <BreadCrumbDS {...props} />
  }
  return <BreadCrumbLegacy {...props} />
}

export default BreadCrumb
export type { BreadCrumbProps } from './bread-crumb.types'
